import { useCallback, useMemo, useState, type PropsWithChildren } from 'react'
import { FocusHorizonOverlay } from '../components/Gamification/FocusHorizonOverlay'
import {
  FocusHorizonContext,
  type FocusHorizonContextValue,
  type FocusHorizonTarget,
} from './focusHorizonContextCore'

export const FocusHorizonProvider = ({ children }: PropsWithChildren) => {
  const [activeTarget, setActiveTarget] = useState<FocusHorizonTarget | null>(null)

  const startFocus = useCallback((target: FocusHorizonTarget) => setActiveTarget(target), [])
  const endFocus = useCallback(() => setActiveTarget(null), [])

  const value = useMemo<FocusHorizonContextValue>(
    () => ({ activeTarget, startFocus, endFocus }),
    [activeTarget, startFocus, endFocus],
  )

  return (
    <FocusHorizonContext.Provider value={value}>
      {children}
      <FocusHorizonOverlay target={activeTarget} onClose={endFocus} />
    </FocusHorizonContext.Provider>
  )
}
